/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//static.glanacion.com/v2/ingresar/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 554);
/******/ })
/************************************************************************/
/******/ ({

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Config) throw new Error("LN.Config missing");
})();

(function (Config, Constantes) {
    'use strict';

    Config.defaultModo = 'D';
    Config.urlViews = window.location.origin + '/views/login/';

    Config.defaultUrl = window.location.origin + '/ingresar/' + Config.defaultModo + '/' + Config.defaultSitioId + '/';

    Config.ingresarPrefix = /ingresar/;
    Config.cambiarClavePrefix = /clave/;

    Config.HotjarHeatmapLogin = Constantes.HotjarHeatmapLogin;

    Config.smartLockEnabled = Constantes.smartLockEnabled;
    Config.smartlockPasswordEnable = Constantes.smartlockPasswordEnable;

    Config.loginProvisorio = Constantes.loginProvisorio;
    // ==================================================
    // Modos permitidos
    // modo (char) = (D) - default / (S) - signwall / (B) - black / (P) - paywall / (C) - cambiar PASSWORD / (V) - VALIDAR CREDENCIAL / (A) - Asignar credencial / (CLA) - Club LN vincular credencial
    // ==================================================      
    Config.Modos = ['D', 'S', 'B', 'P', 'C', 'AT', 'V', 'A', 'GLA', 'CLA'];

    // ==================================================
    // Constantes de backgrounds
    // ==================================================  
    Config.Background = {
        'D': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'C': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'S': {
            'file': 'signwall',
            'class': 'info-signwall'
        },
        'B': {
            'file': 'black',
            'class': 'fondo-black'
        },
        'V': {
            'file': 'black',
            'class': 'fondo-black'
        },
        'P': {
            'file': 'paywall',
            'class': 'info-signwall'
        },
        'A': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'GLA': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'CLA': {
            'file': 'default',
            'class': 'info-signwall'
        }
    };

    Config.Header = {
        'D': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'C': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'S': {
            'file': 'signwall',
            'class': 'info-signwall'
        },
        'B': {
            'file': 'black',
            'class': 'fondo-black'
        },
        'V': {
            'file': 'black',
            'class': 'fondo-black'
        },
        'P': {
            'file': 'paywall',
            'class': 'info-signwall'
        },
        'A': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'GLA': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'CLA': {
            'file': 'default',
            'class': 'info-signwall'
        }
    };

    Config.Titles = {
        'D': {
            'file': 'default'
        },
        'C': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'S': {
            'file': 'signwall'
        },
        'B': {
            'file': 'black'
        },
        'V': {
            'file': 'black'
        },
        'P': {
            'file': 'default'
        },
        'A': {
            'file': 'default'
        },
        'GLA': {
            'file': 'default'
        },
        'CLA': {
            'file': 'default'
        }
    };

    // ==================================================
    // Constantes de steps o pasos
    // ==================================================  
    Config.Step = {
        COOKIES_DESHABILITADAS: {
            file: 'cookies_deshabilitadas',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        INICIO: {
            file: 'inicio',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        ACCEDER_NATIVO_INGRESAR_PASSWORD: {
            file: 'acceder_nativo_ingresar_password',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'acceder_nativo_ingresar_password']
        },
        CREAR_CUENTA_NATIVO: {
            file: 'crear_cuenta_nativo',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_gracias']
        },
        CREAR_CUENTA_DIRECTO: {
            file: 'crear_cuenta_directo_unica',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'crear_cuenta_datos', 'crear_cuenta_directo_unica', 'acceder_red_social', 'facilitar_acceso_google']
        },
        CREAR_CUENTA_DATOS: {
            file: 'crear_cuenta_datos',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_gracias']
        },
        CREAR_CUENTA_PASSWORD: {
            file: 'crear_cuenta_password',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_gracias']
        },
        CREAR_CUENTA_VALIDAR_CODIGO: {
            file: 'crear_cuenta_validar_codigo',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_directo_unica', 'crear_cuenta_password', 'acceder_nativo_ingresar_password', 'crear_cuenta_red_social', 'crear_cuenta_validar_codigo', 'inicio']
        },
        CREAR_CUENTA_GRACIAS: {
            file: 'crear_cuenta_gracias',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_validar_codigo']
        },
        CREAR_CUENTA_RED_SOCIAL: {
            file: 'crear_cuenta_red_social',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'acceder_nativo_caso_1']
        },
        VINCULAR_TARJETA: {
            file: 'vincular_tarjeta',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        ACCEDER_NATIVO_CASO_1: {
            file: 'acceder_nativo_caso_1',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['acceder_nativo_ingresar_password']
        },
        ACCEDER_NATIVO_CASO_2: {
            file: 'acceder_nativo_caso_2',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['acceder_nativo_ingresar_password']
        },
        ACCEDER_RED_SOCIAL: {
            file: 'acceder_red_social',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio']
        },
        REESTABLECER_PASSWORD: {
            file: 'reestablecer_password',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'acceder_nativo_ingresar_password', 'crear_cuenta_gracias']
        },
        REESTABLECER_PASSWORD_CODIGO: {
            file: 'reestablecer_password_codigo',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        REESTABLECER_PASSWORD_CODIGO_GRACIAS: {
            file: 'reestablecer_password_codigo_gracias',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        REESTABLECER_PASSWORD_EXPIRADO: {
            file: 'reestablecer_password_expirado',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['acceder_nativo_caso_1']
        },
        MOSTRAR_ERROR: {
            file: 'mostrar_error',
            title: 'Error',
            flow: []
        },
        ASOCIAR_TARJETA_NO_BLACK: {
            file: 'asociar_tarjeta_no_black',
            title: 'Tarjeta no válida',
            flow: []
        },
        ASOCIAR_TARJETA: {
            file: 'asociar_tarjeta',
            title: 'Asociar Tarjeta',
            flow: []
        },
        REESTABLECER_PASSWORD_ENVIO: {
            file: 'reestablecer_password_envio',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['reestablecer_password']
        },
        FACILITAR_ACCESO_GOOGLE: {
            file: 'facilitar_acceso_google',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'crear_cuenta_directo_unica']
        }
    };
})(LN.Config, window.config.Constantes);

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  if (!LN.Core || !LN.Model) throw new Error("LN.Core || LN.Model missing");
})();

(function (Model, Config, Helper) {
  'use strict';

  Model.Usuario = {
    UsuarioId: "",
    AccessToken: "",
    OrigenLoginTipoId: "",
    TipoAsociarCredencial: "",
    xToken: "",
    xValue: "",
    xKey: "", // Este par�metro solo va para requests de token temporal 
    Retorno: "",
    UsuarioUsuario: "",
    Avatar: 0,
    Email: "",
    EmailCodificado: "",
    UsuarioDetalleNombre: "",
    UsuarioDetalleApellido: "",
    Clave: "",
    Credencial: "",
    Credenciales: [],
    tipoDocumento: "",
    dni: "",
    tipoParticipacion: "",
    UserAgent: "",
    Recaptcha: "",
    Codigo: "",
    SitioId: 1,
    EstadoId: "",
    Ip: "",
    Guid: "",
    UsuarioFacebookId: "",
    FbName: "",
    FbFirstName: "",
    FbLastName: "",
    FbGender: "",
    FbLocale: "",
    FbAgeRange: "",
    FbEmail: "",
    FbBirthday: "",
    FbHometown: "",
    FbLocation: "",
    UsuarioGmailId: "",
    GName: "",
    GFamilyName: "",
    GGivenName: "",
    GBirthday: "",
    GGender: "",
    GCurrentLocation: "",
    GMail: "",
    IsNewUser: false,
    NeedRecaptchaValidation: false,
    HayCookie: 0,
    Experiments: [],
    Provisorio: false
  };

  Model.Window = {
    width: "",
    height: "",
    body: "",
    html: "",
    origenId: "",
    sitioId: "",
    modo: "",
    pagina: "",
    referer: "",
    userAgent: "",
    origenLoginTipoId: "",
    currentStep: "",
    canSubmit: true,
    ip: "",
    keyPress: 0,
    firstStart: true,
    location: window.location.href,
    origin: window.location.origin,
    islockedGmail: false,
    islockedFacebook: false
  };

  Model.Embed = {
    Mobile: false,
    Article: false
  };

  Model.CheckForUpdateArticleContext = function () {
    if (Helper.getURLParameter1('article') != null) {
      Model.Embed.Article = true;
    }
  };

  // ==================================================
  // Inicializacion de las variables de entorno
  // ==================================================       

  Model.updateAccesoWindowModel = function () {
    Model.Window.modo = Helper.getURLParameter('param1') !== null && Helper.modoPermitido(Helper.getURLParameter('param1')) ? Helper.getURLParameter('param1') : Config.defaultModo;
    Model.Window.SitioId = Helper.getURLParameter('param2') !== null && Helper.sitioPermitido(parseInt(Helper.getURLParameter('param2'))) ? parseInt(Helper.getURLParameter('param2')) : Config.defaultSitioId;
    Model.Embed.Mobile = Helper.readCookie("platform") !== '' && Helper.readCookie("platform") != null ? Helper.readCookie("platform") : false;
    Model.CheckForUpdateArticleContext();

    /*
        Todo esto es para el modo = GLA de Google para obtener el callback sin estar hasheado
    
        Todo este parche sigue en Controller.finalizarAcceder, ahí modifico Model.Window.pagina para que la url concuerde con :
            [Redirect_Uri]#access_token=[ACCESS_TOKEN]&token_type=bearer&state=[STATE_STRING]
          Después de eso sigue el camino original del login. Practicamente todo esto es para modificar la url de redireccionamiento y mandarla a donde necesita google.
          Si cuando estás queriendo acceder a la URL con modo GLA, te aparece un error de Client ID o Redirect URI, está pasando adentro de este método : Controller.inicioView, fijate.
        
          (será un parche feo, pero es un parche feo documentado)            
     */

    if (Model.Window.modo === "GLA") {
      var url = new URL(LN.Model.Window.location);
      var googleParams = {
        response_type: Helper.findGetParameter(url, 'response_type'),
        client_id: Helper.findGetParameter(url, 'client_id'),
        redirect_uri: Helper.findGetParameter(url, 'redirect_uri'),
        scope: Helper.findGetParameter(url, 'scope'),
        state: Helper.findGetParameter(url, 'state')

        ///* Validación de client_id */
        //if (Config.gmId != googleParams.client_id) googleParams.errorGLA = "ERROR GOOGLE CLIENT ID"; /*alert("ERROR GOOGLE CLIENT ID");*/

        ///* Validación de redirect_url  */
        //const splitedRedirectUrl = googleParams.redirect_uri.split("/r/");
        //if (Config.gmRedirect != splitedRedirectUrl[0]) googleParams.errorGLA = "ERROR GOOGLE REDIRECT URL";   /*alert("ERROR GOOGLE REDIRECT URL");*/

      };Model.Window.googleParams = googleParams;
    } else {
      // Pagina
      var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$");
      if (Helper.getURLParameter1('callback') != null) {
        if (base64Matcher.test(LN.Helper.getURLParameter1('callback'))) {
          Model.Window.pagina = Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter1('callback'))) ? window.atob(Helper.getURLParameter1('callback')) : Config.defaultRedirectUrl;
        } else {
          Model.Window.pagina = Config.defaultRedirectUrl;
        }
      } else {
        if (base64Matcher.test(LN.Helper.getURLQueryString())) {
          Model.Window.pagina = Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString())) ? window.atob(Helper.getURLQueryString()) : Config.defaultRedirectUrl;
        } else {
          Model.Window.pagina = Config.defaultRedirectUrl;
        }
      }
    }

    //Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString()))) ? window.atob(Helper.getURLQueryString()) : ((Helper.getURLParameter('param3') !== null && Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter('param3')))) ? window.atob(Helper.getURLParameter('param3')) : Config.defaultRedirectUrl)) ;        
    Model.Usuario.SitioId = Model.Window.SitioId;
  };

  Model.updateCambioClaveWindowModel = function () {
    Model.Window.modo = Helper.getURLParameter('param1') !== null && Helper.modoPermitido(Helper.getURLParameter('param1')) ? Helper.getURLParameter('param1') : Config.defaultModo;
    //Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString()))) ? window.atob(Helper.getURLQueryString()) : Config.defaultRedirectUrl);
    if (Helper.getURLParameter1('callback') != null) {
      Model.Window.pagina = Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter1('callback'))) ? window.atob(Helper.getURLParameter1('callback')) : Config.defaultRedirectUrl;
    } else {
      Model.Window.pagina = Config.defaultRedirectUrl;
    }
  };

  Model.updateCambioClaveUsuarioModel = function () {
    Model.Usuario.Guid = Helper.getURLParameter('param2') !== null ? Helper.getURLParameter('param2') : null;
    Model.Usuario.UsuarioId = Helper.getURLParameter('param3') !== null ? Helper.getURLParameter('param3') : null;
  };

  Model.setXKey = function () {
    Model.Usuario.xKey = Helper.guid();
  };

  Model.unsetXKey = function () {
    Model.Usuario.xKey = '';
  };
})(LN.Model, LN.Config, LN.Helper);

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();
(function (App, Service, Handler, Controller, Config, Model, Helper, Analytics, gapi, FB, smartlock, CustomDimension, $) {
    'use strict';

    // ==================================================
    // Llamada ajax generica
    // Params : {url} {data} {success} {error}
    // ==================================================

    Service.ajaxPost = function (url, data, done, _error, options) {
        var sentHeader = !Helper.isEmpty(options) && 'sentHeader' in options ? true : false;
        var showPreloader = !Helper.isEmpty(options) && 'showPreloader' in options ? true : false;
        var hidePreloader = !Helper.isEmpty(options) && 'hidePreloader' in options ? true : false;
        var api = !Helper.isEmpty(options) && 'paywallApi' in options ? Config.apiPaywallUrl : Config.apiLoginUrl;
        var headers = {
            'X-Token': Model.Usuario.xToken || '',
            'X-Value': Model.Usuario.xValue || '',
            'X-Key': Model.Usuario.xKey || ''
        };
        showPreloader && Helper.showPreloader();
        $.ajax({
            url: api + url,
            type: 'POST',
            crossDomain: true,
            data: data || null,
            headers: sentHeader == true ? headers : null,
            success: function success(response, status, xhr) {
                //success && success(response,status,xhr);
            },
            error: function error(response) {
                _error && _error(response);
            },
            complete: function complete(response, status, xhr) {
                if (Config.env === "develop") console.log("Load", url);
            }
        }).done(function (res, status, xhr) {
            try {
                Helper.setCanSubmit(true);
                var r = res;
                if (typeof res == 'string') r = JSON.parse(res);
                done && done(r, status, xhr);
            } catch (e) {
                console.log(e);

                Handler.OnFaildefaultErrorMessage();
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            try {
                Handler.failHandler(jqXHR.status);
            } catch (e) {
                console.log(e);

                Handler.OnFaildefaultErrorMessage();
            }
        });
    };
    // ==================================================
    // Inicializacion de la API de Gmail
    // ==================================================   
    Service.startGmailApi = function () {

        gapi && gapi.load('client:auth2', function () {
            var auth2 = gapi.auth2.init({
                client_id: Config.gmId
            });
        });
    };

    Service.onGmailLogin = function (cb) {
        gapi && gapi.auth2.getAuthInstance().isSignedIn.listen(cb);
    };

    // ==================================================
    // Inicializacion de la API de Facebook
    // ==================================================   
    Service.startFacebookApi = function () {
        FB && FB.init({
            appId: Config.fbId,
            version: 'v5.0',
            status: true,
            cookie: true,
            xfbml: true
        });
    };

    Service.getFbMe = function (cb) {
        window.FB && window.FB.api('/me?fields=name,email,age_range,currency,first_name,last_name,gender,locale,birthday,hometown,location', function (response) {
            cb && cb(response);
            //Controller.accederFacebookProcesar(response);
        });
    };

    Service.startHotjar = function () {
        (function (h, o, t, j, a, r) {
            h.hj = h.hj || function () {
                (h.hj.q = h.hj.q || []).push(arguments);
            };
            h._hjSettings = { hjid: parseInt(Config.hotjarId), hjsv: 6 };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    };

    Service.createCustomDimension = function () {

        if (!CustomDimension.exist()) {
            CustomDimension.setRegistrado('no');
            CustomDimension.setSuscriptorType('N/A');
            CustomDimension.setUserId('');
            CustomDimension.save();
        }

        var CD = CustomDimension.get();
        var withToken = Helper.isEmpty(Helper.readCookie('token'));
        var usuarioLogeado = withToken ? 'no' : 'yes';
        var payUser = Helper.isEmpty(Helper.readCookie('ProductoPremiumId')) ? 'no' : 'yes';
        var userId = Helper.readCookie('usuario%5Fid');
        var clubLN = Helper.readCookie('usuarioDetalleClubNacion');
        var notasLeidas = Helper.readCookie('countNotas');

        if (!window.dataLayer) {
            window.dataLayer = [{}];
        }

        dataLayer[0].notasLeidas = notasLeidas ? notasLeidas : 0;
        dataLayer[0].usuarioLogeado = usuarioLogeado;
        dataLayer[0].usuarioRegistrado = CD.usuarioRegistrado;
        dataLayer[0].payUser = payUser;
        dataLayer[0].suscriptorType = CD.suscriptorType;
        dataLayer[0].userId = CD.userId;
        dataLayer[0].credentialType = clubLN ? clubLN : 'N/A';
    };

    Service.startGoogleAnalytics = function () {
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
        ga && ga('create', Config.gaId, 'auto');
    };

    Service.initializeGoogleAnalytics = function () {
        if (typeof ga === 'function' && ga.loaded) {
            return;
        }

        (function init() {
            if (typeof ga === 'function') {
                ga('create', Config.gaId, 'auto');
            } else {
                setTimeout(init, 100);
            }
        })();
    };

    Service.startGoogleTagManager = function () {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];w[l].push({
                'gtm.start': new Date().getTime(), event: 'gtm.js'
            });var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&amp;l=' + l : '';j.async = true;j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', Config.gtmId);
    };

    Service.startComscore = function () {
        var _comscore = _comscore || [];
        _comscore.push({ c1: "2", c2: "6906398" });
        (function () {
            var s = document.createElement("script"),
                el = document.getElementsByTagName("script")[0];s.async = true;
            s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
            el.parentNode.insertBefore(s, el);
        })();
    };

    Service.startEstadisticas = function () {
        var rand_no = Math.random();
        var ip = '190.220.56.0'; /* NO SOY FELIZ HACIENDO ESTO -- ALE */
        rand_no = Math.ceil(rand_no * 1000000000);
        $("body").append('<img src="https://estadisticas.lanacion.com.ar/diario/default.gif?pagina=' + Model.Window.location + '&amp;servidor=' + ip + '&amp;nro=' + rand_no + '" width="1" height="1" />');
    };

    Service.mostrarError = function (message, analyticsError, error) {
        Analytics.error(analyticsError || message);
        Helper.callView('MOSTRAR_ERROR', {
            message: message,
            error: error
        });
    };

    Service.mostrarErrorTrackeaForm = function (message, analyticsError, error) {
        Analytics.formError(Helper.getCurrentStep() + '-' + analyticsError);
        Helper.callView('MOSTRAR_ERROR', {
            message: message,
            error: error
        });
    };

    Service.isLogged = function () {
        Model.Usuario.xToken = Helper.readCookie("token");
        var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
        var cookieLogin = Helper.readCookie("cookieLogin");
        if (Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(Model.Usuario.xToken) || Helper.Validators.temporary.test(Model.Usuario.xToken)) return false;
        Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
            if (!Helper.isEmpty(res.code) && res.code === '0000') {

                Helper.returnBack({
                    url: Model.Window.pagina
                });
            }
        }, null, {
            sentHeader: true
        });
    };

    Service.isLoggedONLY = function () {
        Model.Usuario.xToken = Helper.readCookie("token");
        var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
        var cookieLogin = Helper.readCookie("cookieLogin");
        if (Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(Model.Usuario.xToken) || Helper.Validators.temporary.test(Model.Usuario.xToken)) return false;
        return true;
    };

    Service.ifLoggedNextStep = function () {
        if (Service.isLoggedONLY()) {
            var step = $('.next-step').data('step');
            if (step) Handler.stepHandler(step);
        }
    };

    Service.ifLoggedReturnBack = function () {
        setInterval(function () {
            Service.isLogged();
        }, Config.returnBackInterval);
    };

    Service.getFacebookInfo = function () {
        window.FB && window.FB.getLoginStatus(function (response) {
            if (response.status == 'connected') {
                window.FB.api('/' + response.authResponse.userID, 'GET', {
                    "fields": "first_name,last_name"
                }, function (response) {
                    if (!Helper.isEmpty(response.first_name)) {
                        var mensaje = '&iquest;No sos ' + response.first_name + ' ' + response.last_name + '?';
                        $('.boton-fb a').html(mensaje);
                        $(".boton-fb a").fadeIn("slow");
                    } else {
                        $(".boton-fb a").fadeOut("slow");
                    }
                });
            } else {
                $(".boton-fb a").fadeOut("slow");
            }
        });
    };

    Service.getGmailInfo = function () {
        gapi && gapi.client.load('plus', 'v1', function () {
            var request = gapi.client.plus.people.get({ 'userId': 'me' });
            request.execute(function (profile) {
                if (!Helper.isEmpty(profile.displayName)) {
                    var mensaje = '&iquest;No sos ' + profile.displayName + '?';
                    $(".boton-gm a").html(mensaje);
                    $(".boton-gm a").fadeIn("slow");
                }
            });
        });
    };

    Service.logoutFacebook = function () {
        var url = window.location.href;
        window.FB && window.FB.logout(function (response) {
            $(".boton-fb a").fadeOut("slow");
            window.location.href = url;
        });
    };

    Service.logoutGmail = function () {
        var gaInstance = gapi.auth2.getAuthInstance();

        if (gaInstance.isSignedIn.get()) {
            gaInstance.disconnect().then(function () {
                $(".boton-gm a").fadeOut("slow");
            });
        }
    };

    // ==================================================
    // Setup App
    // ==================================================   
    Service.setup = function () {};

    // =================================================
    // Smart Lock
    // =================================================
    Service.autoLogin = function () {
        if (Config.smartLockEnabled) {
            smartlock && smartlock.get(function (r) {
                var cred = r.credential;
                if (cred) {

                    var logTest = /Contrase�a|Email/;
                    if (logTest.test(cred.id)) {
                        // El nombre de la credencial se un dato incorrecto, logea en elmah
                        logger && logger.error('Smartlock | nombre credencial incorrecta', cred);
                    }

                    switch (r.type) {
                        case 'nativo':
                            Controller.accerNativoAutomatico(cred.id, cred.password);
                            console.log('acceso automatico nativo: ' + cred.name);
                            break;
                        case 'fb':
                            Controller.accederFacebookAutomatico(cred.id);
                            console.log('acceso automatico Facebook: ' + cred.name);
                            break;
                        case 'gm':
                            Controller.accederGmailAutomatico(cred.id);
                            console.log('acceso automatico Google: ' + cred.name);
                            break;
                    }
                }
            }, Config.smartlockPasswordEnable);
        }
    };
    Service.storeFB = function (profile) {
        if (!Config.smartLockEnabled) return;
        if (!profile) return;
        var email = profile.email;
        var name = profile.name;
        var iconUrl = 'https://graph.facebook.com/' + profile.id + '/picture?type=small';
        smartlock && smartlock.saveFacebook(email, name, iconUrl);
    };
    Service.storeGM = function (profile) {
        if (!Config.smartLockEnabled) return;
        if (!profile) return;
        var email = profile.getEmail();
        var name = profile.getName();
        var iconUrl = profile.getImageUrl();
        smartlock && smartlock.saveGmail(email, name, iconUrl);
    };
    Service.storeNativo = function (usuario) {
        if (!Config.smartLockEnabled) return;
        if (!Config.smartlockPasswordEnable) return;
        var email = usuario.Email;
        var password = usuario.Clave;
        var name = usuario.UsuarioDetalleNombre + ' ' + usuario.UsuarioDetalleApellido;
        var iconUrl = Config.urlImages + '/avatar/avatar-' + usuario.Avatar + '.jpg';
        smartlock && smartlock.savePassword(email, password, name, iconUrl);
    };

    Service.smartlockSignOut = function () {
        smartlock && smartlock.signOut();
    };

    Service.displayCookiesDeshabilitadasView = function () {
        Handler.setOrigin();
        Helper.addBackground(function () {
            Helper.addHeader();
            Helper.callView('COOKIES_DESHABILITADAS', null, function () {
                $('#btnReloadPage').click(function () {
                    location.reload();
                });
            });
            Helper.resizeHandler();
        });
    };
})(LN.App, LN.Service, LN.Handler, LN.Controller, LN.Config, LN.Model, LN.Helper, LN.Analytics, window.gapi, window.FB, window.smartlock, LN.CustomDimension, jQuery);

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window.LN = window.LN || {};
LN.App = {};
LN.Core = {};
LN.Config = {};
LN.Model = {};
LN.Service = {};
LN.Helper = {};
LN.LocalStorage = {};
LN.Controller = {};
LN.Handler = {};
LN.Message = {};
LN.Message.Analytics = {};
LN.Analytics = {};
LN.Hotjar = {};
LN.CustomDimension = {};
// Quitar cuando se defina el logger en Login.
window.logger = null;

if (!Object.values) {
    Object.values = function (object) {
        return Object.keys(object).map(function (key) {
            return object[key];
        });
    };
}

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(193);

var _core2 = _interopRequireDefault(_core);

var _config = __webpack_require__(84);

var _config2 = _interopRequireDefault(_config);

var _config3 = __webpack_require__(189);

var _config4 = _interopRequireDefault(_config3);

var _model = __webpack_require__(190);

var _model2 = _interopRequireDefault(_model);

var _service = __webpack_require__(191);

var _service2 = _interopRequireDefault(_service);

var _helperLogout = __webpack_require__(541);

var _helperLogout2 = _interopRequireDefault(_helperLogout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ==============================================

// IMPORTS ======================================
//** CORE
(function (Model, Service, Config, Helper, $) {
    // console.log('logout/logout.html');
    var url = decodeURI(window.location);
    var queryString = url.replace(/^[^\?]+\??/, '');
    var params = tb_parseQuery(queryString);
    var pagina = params['pagina'];

    logout({
        url: pagina
    });

    function tb_parseQuery(query) {
        var Params = {};
        if (!query) {
            return Params;
        } // return empty object
        var Pairs = query.split(/[|]/);
        for (var i = 0; i < Pairs.length; i++) {
            var KeyVal = Pairs[i].split('=');
            if (!KeyVal || KeyVal.length != 2) {
                continue;
            }
            var key = unescape(KeyVal[0]);
            var val = unescape(KeyVal[1]);
            val = val.replace(/\+/g, ' ');
            Params[key] = val;
        }
        //console.log("tb_parseQuery.Params = " + Params);
        return Params;
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function logout(options) {
        try {
            Model.Usuario.xToken = readCookie("token");
            Model.Usuario.xValue = readCookie("xvalue");
            if (Model.Usuario.xToken != null && Model.Usuario.xValue != null && Model.Usuario.xToken && Model.Usuario.xValue) {
                ajaxPost('/Usuario/Logout', Model.Usuario, function (res, status, xhr) {
                    //Service.smartlockSignOut();
                    Helper.resetAll();
                    returnBackLogout(options);
                }, function () {
                    Helper.resetAll();
                    returnBackLogout(options);
                }, {
                    sentHeader: true
                });
            }
        } catch (ex) {
            console.warn(ex);
        }
    }
    function redirectUrl(url) {
        window.location = url;
    }

    function returnBackLogout(options) {
        var pagina = !isEmpty(options) && !isEmpty(options.url) ? options.url : Model.Window.pagina;
        if (!isEmpty(pagina)) redirectUrl(pagina || Config.defaultRedirectUrl);
    }

    function isEmpty(obj) {
        if (obj == null) return true;
        if (obj.length > 0) return false;
        if (obj.length === 0) return true;
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }

    function ajaxPost(url, data, done, _error, options) {
        var sentHeader = !isEmpty(options) && 'sentHeader' in options ? true : false;
        var showPreloader = !isEmpty(options) && 'showPreloader' in options ? true : false;
        var hidePreloader = !isEmpty(options) && 'hidePreloader' in options ? true : false;
        var api = !isEmpty(options) && 'paywallApi' in options ? Config.apiPaywallUrl : Config.apiLoginUrl;
        var headers = {
            'X-Token': Model.Usuario.xToken || '',
            'X-Value': Model.Usuario.xValue || '',
            'X-Key': Model.Usuario.xKey || ''
        };
        $.ajax({
            url: api + url,
            type: 'POST',
            crossDomain: true,
            data: data || null,
            headers: sentHeader == true ? headers : null,
            success: function success(response, status, xhr) {
                //success && success(response,status,xhr);
            },
            error: function error(response) {
                _error && _error(response);
            },
            complete: function complete(response, status, xhr) {}
        }).done(function (res, status, xhr) {
            try {
                var r = res;
                if (typeof res == 'string') r = JSON.parse(res);
                done && done(r, status, xhr);
            } catch (e) {
                console.log(e);
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            _error && _error(jqXHR);
        });
    }
})(LN.Model, LN.Service, LN.Config, LN.Helper, jQuery);

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();

(function (Helper, Config, Model, $) {
    'use strict';

    // ==================================================
    // Valida si esta vacio cualquier tipo de dato
    // Params : {obj} || {arr} || {str}
    // ==================================================

    Helper.isEmpty = function (obj) {
        if (obj == null) return true;
        if (obj.length > 0) return false;
        if (obj.length === 0) return true;
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    };

    // ==================================================
    // Lee el valor de una cookie
    // Params : {str}
    // ==================================================   
    Helper.readCookie = function (name) {
        logger && logger.debug('readCookie [' + name + ']');
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };

    // ==================================================
    // Borra todas las cookies
    // ==================================================   
    Helper.deleteAllCookies = function () {
        logger && logger.debug('deleteAllCookies');
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            if (Config.DiccionarioCookiesAGuardar.indexOf(name.trim()) > -1) {
                if (document.domain === 'localhost') {
                    //console.log("Delete Cookie - Name : " + name);
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
                } else {
                    //console.log("Delete Cookie - Name : " + name);
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
                }
            }
        }
    };
    // ==================================================
    // Limpia el modelo, cookies y resetea parametros de URL
    // ==================================================   
    Helper.resetAll = function (cb) {
        var token = Helper.readCookie("token");
        var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
        var cookieLogin = Helper.readCookie("cookieLogin");

        $(':input').val('');
        for (var index in Model.Usuario) {
            Model.Usuario[index] = '';
        }
        Helper.deleteAllCookies();
        if (!(Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(token))) {
            Model.Usuario.HayCookie = 1;
        }
        Model.Usuario.SitioId = Model.Window.SitioId;
        cb && cb();
    };
})(LN.Helper, LN.Config, LN.Model, jQuery);

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(534);


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (Config, Constantes) {

    Config.defaultSitioId = Constantes.defaultSitioId;
    Config.apiVersion = Constantes.apiVersion;
    Config.cookieExpirationTime = Constantes.TimeExpiration;
    Config.keyPressLimit = Constantes.keyPressLimit;
    Config.freezeTime = Constantes.freezeTime;
    Config.returnBackInterval = Constantes.returnBackInterval;
    Config.dominioCookie = Constantes.dominioCookie || 'localhost';

    Config.disableValidations = Constantes.disableValidations;
    Config.enableQuickView = Constantes.enableQuickView;
    Config.forceCreateNewAddress = Constantes.forceCreateNewAddress;
    Config.elmahLevel = Constantes.elmahLevel;

    // =================================================
    // Dominios
    // =================================================
    Config.apiLoginUrl = Constantes.Dominios.apiLogin;
    Config.apiPaywallUrl = Constantes.Dominios.apiPaywall;
    Config.urlStatic = Constantes.Dominios.static;
    Config.defaultRedirectUrl = Constantes.Dominios.lanacion;
    Config.urlImages = Constantes.Dominios.static + "/images";
    Config.dominioMiCuenta = Constantes.Dominios.micuenta;
    Config.dominioLaNacion = Constantes.Dominios.lanacion;
    Config.urlPassport = Constantes.Dominios.passport;
    Config.urlMiClub = Constantes.Dominios.miclub;
    Config.urlBucket = Constantes.Dominios.bucket + '/Club.LN/anexos/fotos/productos/';
    // =================================================
    // Api Keys
    // =================================================
    Config.wCentrixTime = Constantes.wCentrixTime;
    Config.idWcentrix = Constantes.idWcentrix;
    Config.hotjarId = Constantes.idHotjar;
    Config.fbId = Constantes.fbId;
    Config.gmId = Constantes.gmId;
    Config.gmRedirect = Constantes.gmRedirect;
    Config.rcId = Constantes.rcId;
    Config.gaId = Constantes.gaId;
    Config.gtmId = Constantes.gtmId;
    Config.SentryPaywall = Constantes.sentry_paywall || null;
    Config.SentryIngresar = Constantes.sentry_ingresar || null;

    // ==================================================
    // Sitios Ids Asociar Tarjeta post-login
    // 6 - Club LN / 7 - Autogestión/MiClub
    // ==================================================  
    Config.SitiosAsociarCredencial = Object.values(Constantes.SitiosAsociarCredencial);

    // ==================================================
    // Sitios Ids Permitidos
    // 1 - webLN / 2 - webCLL / 3 - webOH / 4 - appLN / 6 - Club LN / 7 - Autogestión/MiClub / 8 - Experiencias Black
    // ==================================================
    Config.Sitios = Constantes.Sitios;

    // ==================================================
    // Dominios permitidos a redireccionar
    // ==================================================  
    Config.dominiosPermitidos = RegExp(Constantes.dominiosPermitidos);

    // ========================================================
    // Diccionario de keys de usuario para grabar en cookies
    // ========================================================
    Config.DiccionarioCookiesAGuardar = Object.values(Constantes.DiccionarioCookiesAGuardar);
})(LN.Config, window.config.Constantes);

/***/ })

/******/ });


// WEBPACK FOOTER //
// scripts/logout.20f7187.min.js